import { Box, LinkChevron, Text } from '@origin-digital/style-guide';

import React from 'react';
import analytics from '../../../../analytics';
import CheckCircleIcon from '../../../../components/Icons/CheckCircleIcon';

import { ThankYouProps } from './ThankYou.types';

export default class ThankYou extends React.Component<ThankYouProps> {
  componentDidMount() {
    analytics.pageLoad('thankyou');
  }

  render() {
    const { metaData } = this.props;

    return (
      <Box display={'flex'} flexWrap={true} justifyContent={'center'}>
        <Box maxWidth={360} alignSelf={'center'}>
          <Box marginBottom={4} display={'flex'} flexWrap={true} justifyContent={'center'}>
            <CheckCircleIcon size={33} color={'lightGreen'} />
          </Box>
          <Text align={'center'}>{metaData.form.content.successMessage}</Text>
          <Box marginTop={4}>
            <Text align={'center'}>{metaData.form.content.successMessagePart2}</Text>
          </Box>
          <Box marginTop={4} display={'flex'} flexWrap={true} justifyContent={'center'} cursor={'pointer'}>
            <LinkChevron href={metaData.form.content.solarLink.href} text={metaData.form.content.solarLink.text} />
          </Box>
        </Box>
      </Box>
    );
  }
}
